import { render, staticRenderFns } from "./newsPage.vue?vue&type=template&id=5027e32e&scoped=true&"
import script from "./newsPage.vue?vue&type=script&lang=js&"
export * from "./newsPage.vue?vue&type=script&lang=js&"
import style0 from "./newsPage.vue?vue&type=style&index=0&id=5027e32e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5027e32e",
  null
  
)

export default component.exports